import NavigationBar from '../../components/NavigationBar/NavigationBar';
import Header from '../../components/Header/Header';
import Summary from '../../components/Summary/Summary';
import TabSection from '../../components/Tabs/TabSection';
import { useAtom } from 'jotai';
import { filteredIncentivesData, filteredIncentivesDataIndex } from '../../state/GlobalState';
import { emptyIncentiveData, IncentiveApiData } from '../../types/IncentivesDataType';
import { resetSuperScriptLinks } from '../../components/SuperScriptLink/SuperScriptLink';
import { useEffect } from 'react';
import { constructDigitalData, fireAnalyticsEvent } from '../../analytics/analytics';
import {
    INCENTIVE_DETAILS_PAGE_NAME,
    GLOBAL_LOAD,
    COOKIE_PREFERENCES,
    FPG_COOKIES,
} from '../../analytics/analyticsConstants';
import { useUniversalContext } from '@cxc/react-universal-components';

const IncentiveDetails = () => {
    const { isLoggedIn, subscribeScopedValue } = useUniversalContext();
    const cookiePreferences = subscribeScopedValue(FPG_COOKIES, COOKIE_PREFERENCES);
    useEffect(() => {
        resetSuperScriptLinks();
    }, []);

    useEffect(() => {
        const digitalData = constructDigitalData(
            INCENTIVE_DETAILS_PAGE_NAME,
            GLOBAL_LOAD,
            isLoggedIn,
            cookiePreferences,
        );
        fireAnalyticsEvent(digitalData.digitalData, digitalData.directCallName);
    }, [cookiePreferences, isLoggedIn]);

    const [filteredIncentives] = useAtom<IncentiveApiData[]>(filteredIncentivesData);
    const [index] = useAtom<number>(filteredIncentivesDataIndex);
    const incentive =
        index < filteredIncentives.length ? filteredIncentives[index] : emptyIncentiveData;

    return (
        <>
            <Header />
            <NavigationBar
                title={incentive ? incentive.incentiveName : 'NULL'}
                showNextPrevButtons={false}
            />
            <Summary incentive={incentive} />
            <TabSection incentive={incentive} />
        </>
    );
};

export default IncentiveDetails;
